import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';

// src/helpers/factories/settings/licenseFactory.ts
var licensesDropdownOptionsFactory = (licenses, licenseSettings, currentLicenses) => {
  let options = Object.entries(licenses).map(([key, license]) => {
    var _a;
    return {
      label: ((_a = licenseSettings[license.licenseSettingsId]) == null ? void 0 : _a.nickname) || "No nickname",
      value: Number(key)
    };
  });
  const currentLicensesSet = new Set(currentLicenses || []);
  options = options.filter((option) => !currentLicensesSet.has(option.value));
  return options;
};
var languageValue = {
  en: 1,
  es: 2
};
var valueToLanguage = {
  1: "en",
  2: "es"
};
var displayModeValue = {
  light: 1,
  dark: 2
};
var valueToDisplayMode = {
  1: "light",
  2: "dark"
};
var fontSizeValue = {
  small: 1,
  normal: 2,
  large: 3
};
var valueToFontSize = {
  1: "small",
  2: "normal",
  3: "large"
};
var restaurantModeValue = {
  default: 0,
  qsr: 1,
  tsr: 2
};
var valueToRestaurantMode = {
  0: null,
  1: "qsr",
  2: "tsr"
};
var getLanguageDropdownOptions = () => {
  return [
    [
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.languageDropdownOptions.english"
        ),
        value: 1
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.languageDropdownOptions.spanish"
        ),
        value: 2
      }
    ]
  ];
};
var getDisplayModeDropdownOptions = () => {
  return [
    [
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.displayModeDropdownOptions.light"
        ),
        value: 1
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.displayModeDropdownOptions.dark"
        ),
        value: 2
      }
    ]
  ];
};
var getFontSizeDropdownOptions = () => {
  return [
    [
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.fontSizeDropdownOptions.small"
        ),
        value: 1
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.fontSizeDropdownOptions.normal"
        ),
        value: 2
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.fontSizeDropdownOptions.big"
        ),
        value: 3
      }
    ]
  ];
};
var restaurantModeDropdownOptions = () => {
  return [
    [
      {
        label: i18n_config_default.t("commonTexts.default"),
        value: 0
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.restaurantModeDropdownOptions.qsr"
        ),
        value: 1
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.basicSettings.restaurantModeDropdownOptions.tsr"
        ),
        value: 2
      }
    ]
  ];
};
var sendAndPayOverrideValue = {
  default: 0,
  ["send_only" /* SEND_ONLY */]: 1,
  ["pay_only" /* PAY_ONLY */]: 2,
  ["both" /* BOTH */]: 3
};
var valueToSendAndPayOverride = {
  0: null,
  1: "send_only" /* SEND_ONLY */,
  2: "pay_only" /* PAY_ONLY */,
  3: "both" /* BOTH */
};
var sendToKitchenOverrideValue = {
  default: 0,
  ["payment initiated" /* paymentInitiated */]: 1,
  ["payment completed" /* paymentCompleted */]: 2
};
var valueToSendToKitchenOverride = {
  0: null,
  1: "payment initiated" /* paymentInitiated */,
  2: "payment completed" /* paymentCompleted */
};
var getSendAndPayOverrideDropdownOptions = () => {
  return [
    [
      {
        label: i18n_config_default.t("commonTexts.default"),
        value: 0
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.quickServiceOrderSettings.sendAndPayOverrideDropdownOptions.sendOnly"
        ),
        value: 1
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.quickServiceOrderSettings.sendAndPayOverrideDropdownOptions.payOnly"
        ),
        value: 2
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.quickServiceOrderSettings.sendAndPayOverrideDropdownOptions.both"
        ),
        value: 3
      }
    ]
  ];
};
var getSendToKitchenOverride = () => {
  return [
    [
      {
        label: i18n_config_default.t("commonTexts.default"),
        value: 0
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.quickServiceOrderSettings.SendToKitchenOverrideDropdownOptions.paymentInitiated"
        ),
        value: 1
      },
      {
        label: i18n_config_default.t(
          "settingsModule.licenseSettings.quickServiceOrderSettings.SendToKitchenOverrideDropdownOptions.paymentCompleted"
        ),
        value: 2
      }
    ]
  ];
};

export { displayModeValue, fontSizeValue, getDisplayModeDropdownOptions, getFontSizeDropdownOptions, getLanguageDropdownOptions, getSendAndPayOverrideDropdownOptions, getSendToKitchenOverride, languageValue, licensesDropdownOptionsFactory, restaurantModeDropdownOptions, restaurantModeValue, sendAndPayOverrideValue, sendToKitchenOverrideValue, valueToDisplayMode, valueToFontSize, valueToLanguage, valueToRestaurantMode, valueToSendAndPayOverride, valueToSendToKitchenOverride };
